import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import '../../App.css';
import { styled } from '../../components/styled';
import SpRadio from '../../components/atoms/SpRadio';
import SpText from '../../components/atoms/SpText';
import SpButton from '../../components/atoms/SpButton';
import SpTextInput from '../../components/atoms/SpTextInput';
import SpTextArea from '../../components/atoms/SpTextArea';
import { Add, ArrowBack, Close } from '@material-ui/icons';
import moment from 'moment';
import { Button as MuiButton, Divider, FormControlLabel, Grid, Radio } from '@material-ui/core';
import { SpSelect, SpSelectMenuItem } from '../../components/atoms/SpSelect';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { theme, theme as themeStyle } from '../../components/theme';
import { createStation, findStationById, updateStation } from '../../models/actions/Stations';
import { nanoid } from 'nanoid';
import Geocode from 'react-geocode';
import SpIconButton from '../../components/atoms/SpIconButton';
import SpGoogleMarker from '../../components/bundles/googleMaps/SpGoogleMarker';
import SpGoogleMap from '../../components/bundles/SpGoogleMap';
import { UserSessionContext } from '../../App';

//Setting up geocode
Geocode.setApiKey('AIzaSyC0KvC-l9aD8fS42m3aVZytFL893tMCw4A');
Geocode.setLanguage('it');
Geocode.setRegion('it');

const CustomRadioButton = styled(Radio)({
  color: themeStyle.colors.mainGreen.secondary,
  border: `1px solid ${themeStyle.colors.mainGreen.secondary}`
});

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const StationDetail = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [selectedActivityType, setSelectedActivityType] = useState(null);
  const [inputError, setInputError] = useState(false);
  const [error, setError] = useState(null);
  const [tariffesError, setTariffesError] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const { authData, setAuthData } = useContext(UserSessionContext);

  const { stationId } = useParams();
  const history = useHistory();

  const { register, control, getValues, handleSubmit, reset, setValue, errors } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'station_payments',
    keyName: 'key',
    defaultValues: []
  });

  const paymentTypes = [
    { id: 1, name: 'Tariffa oraria' },
    { id: 2, name: 'Tariffa speciale' },
    { id: 3, name: 'Cauzione' }
  ];

  const fetchData = async () => {
    if (stationId) {
      try {
        let response = await findStationById({ id_station: stationId }, authData.accessToken);
        if (response) {
          reset({ ...response });
          setSelectedPosition({ lat: response.lat, lng: response.lng });
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  const checkSelectedTimeslots = (stationPaymentsData) => {
    //check to see if at least one value is selected from the dropdown
    const recordNotNullFound = stationPaymentsData.filter(
      (e) => (e.type == 1 && parseInt(e.hour_number) > 0 && parseFloat(e.amount_to_pay) >= parseFloat(1)) || (e.type == 2 && e.start_date && e.end_date && parseFloat(e.amount_to_pay) >= parseFloat(1)) || (e.type == 3 && parseFloat(e.amount_to_pay) >= parseFloat(2.8))
    );
    const depositAmountFound = stationPaymentsData.filter((elem) => elem.type === 3);
    if (recordNotNullFound.length == stationPaymentsData.length && depositAmountFound.length === 1) {
      return false;
    } else {
      setTariffesError('Devi compilare i campi delle tariffe. Le tarrifee devono essere maggiori di 1.00€ e la cauzione maggiore di 2.80€. La cazione deve essere una sola.');
      return true;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveStation = async (data) => {
    console.log(data);
    const userID = authData.userId;
    if (checkSelectedTimeslots(data.station_payments)) return;
    try {
      props.isLoading(true);
      if (stationId) {
        if (selectedPosition) {
          const response = await updateStation({ station: { ...getValues(), id: stationId, id_user: userID, lat: selectedPosition.lat, lng: selectedPosition.lng } }, authData.accessToken);
          if (response) {
            setCurrentStation(response);
            props.snackbarShowMessage(response.message);
          }
          setInputError(false);
        } else {
          setInputError(true);
        }
        props.isLoading(false);
      } else {
        if (selectedPosition) {
          const response = await createStation({ station: { ...getValues(), id_user: userID, lat: selectedPosition.lat, lng: selectedPosition.lng } }, authData.accessToken);
          props.isLoading(false);
          response && history.push('/stations');

          setInputError(false);
        } else {
          setInputError(true);
        }
        props.isLoading(false);
      }
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  const handlePositionChose = (dataFromMap) => {
    reset({ ...getValues(), lat: dataFromMap.lat, lng: dataFromMap.lng });
    setSelectedPosition({ lat: dataFromMap.lat, lng: dataFromMap.lng });
  };

  const removeTariffes = (p) => {
    //removing the element from the list of tariffes
    remove(fields.findIndex((e) => e.id == p.id));
  };

  const formControlStyleCheck = { width: 30, color: 'black' };
  const formControlStyleInput = { width: '100%', marginTop: '1%' };

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        {stationId && (
          <Grid
            item
            container
            xs={12}
            spacing={1}
            justifyContent="flex-end"
          >
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Ebike'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push({ pathname: `/stations/edit/${stationId}/ebikes`, state: { stationData: getValues() && stationId ? getValues() : currentStation } })}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Noleggi'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/rents`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Prenotazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reservations`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Segnalazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reports`)}
              />
            </Grid>
          </Grid>
        )}
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push('/stations')}
                style={{ width: 25, color: themeStyle.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {stationId ? `Home / Stazione / ` : `Home / Stazione `}
              </SpText>
              <SpText variant="breadcrumbsSelected">{getValues('name') && stationId ? getValues('name') : currentStation?.name}</SpText>
            </TitleToolbarSection>
          </Grid>

          {/* {stationId ? (
						<Grid item xs={3}>
							<SpButton buttonType='accept' text={"Modifica"} style={{ width: "100%" }} variant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					) : (
						<Grid item xs={3}>
							<SpButton buttonType='accept' text={"Salva"} style={{ width: "100%" }} ariant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					)} */}
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
          style={{ backgroundColor: 'rgb(77, 172, 39,0.7)' }}
        >
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            {stationId ? (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Modifica'}
                  style={{ width: '100%' }}
                  variant="h1PageTitle"
                  onClick={handleSubmit(saveStation)}
                />
              </Grid>
            ) : (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Salva'}
                  style={{ width: '100%' }}
                  ariant="h1PageTitle"
                  onClick={handleSubmit(saveStation)}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Grid
              item
              xs={12}
            >
              {error && <SpText variant="h4ComponentLabelError">{error}</SpText>}
              {tariffesError && <SpText variant="h4ComponentLabelError">{tariffesError}</SpText>}
            </Grid>
            <form>
              <SpTextInput
                label="Numero di telefono assistenza (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="support_phone"
              />
              <SpTextInput
                label="Numero di telefono per allarme sicurezza (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="alarm_phone"
              />
              <Divider style={{ height: '2px', backgroundColor: theme.colors.mainGreen.main, marginTop: 10 }} />

              <SpText
                variant="formText"
                style={{ marginTop: 10 }}
              >
                Inserimento tariffe
              </SpText>

              <Grid
                container
                direction="column"
              >
                <Grid
                  item
                  xs={2}
                  container
                  justifyContent="flex-start"
                  align-items="center"
                >
                  <SpSelect
                    value={selectedActivityType}
                    label="Scegli tipologia tariffa"
                    labelColor={'black'}
                    onChange={(e) => {
                      setSelectedActivityType(e.target.value);
                    }}
                  >
                    {paymentTypes.map((value) => (
                      <SpSelectMenuItem
                        key={value.id}
                        value={value.id}
                      >
                        {value.name}
                      </SpSelectMenuItem>
                    ))}
                  </SpSelect>
                  <SpIconButton
                    buttonType={'accept'}
                    small
                    style={{ marginTop: 30 }}
                    disabled={!selectedActivityType}
                    onClick={() => (selectedActivityType == 1 ? append({ id: nanoid(), type: selectedActivityType, hour_number: 0, amount_to_pay: 0 }) : append({ id: nanoid(), type: selectedActivityType, start_date: new Date(), end_date: new Date(), start_date: new Date(), amount_to_pay: 0 }))}
                  >
                    <Add />
                  </SpIconButton>
                </Grid>
                {fields.map((p, idx) => {
                  console.log(p);
                  switch (p.type) {
                    case 1:
                      return (
                        <Grid
                          key={p.id}
                          item
                          xs={12}
                          container
                          alignItems="center"
                        >
                          <Grid
                            item
                            xs={4}
                          >
                            <SpTextInput
                              label="Monte ore"
                              labelColor={'black'}
                              type="number"
                              formControlStyle={formControlStyleInput}
                              variant="inputLabel"
                              inputRef={register}
                              name={`station_payments[${idx}].hour_number`}
                              defaultValue={p.hour_number}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={4}
                          >
                            <SpTextInput
                              label="Tariffa rispettiva (€)"
                              labelColor={'black'}
                              type="number"
                              formControlStyle={formControlStyleInput}
                              variant="inputLabel"
                              inputRef={register}
                              name={`station_payments[${idx}].amount_to_pay`}
                              defaultValue={p.amount_to_pay}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={4}
                          >
                            <SpIconButton
                              small
                              buttonType={'accept'}
                              style={{ marginTop: 25 }}
                              onClick={() => removeTariffes(p)}
                            >
                              <Close />
                            </SpIconButton>
                          </Grid>
                        </Grid>
                      );
                    case 2:
                      return (
                        <Grid
                          key={p.id}
                          item
                          xs={12}
                          container
                          alignItems="center"
                          justifyContent="space-evenly"
                        >
                          <Grid
                            item
                            xs={3}
                          >
                            <SpTextInput
                              label="Data inizio periodo"
                              labelColor={'black'}
                              type="date"
                              formControlStyle={formControlStyleInput}
                              variant="inputLabel"
                              inputRef={register}
                              name={`station_payments[${idx}].start_date`}
                              defaultValue={moment(p?.rent?.start_date ?? moment()).format('YYYY-MM-DD')}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                          >
                            <SpTextInput
                              label="Data fine periodo"
                              labelColor={'black'}
                              type="date"
                              formControlStyle={formControlStyleInput}
                              variant="inputLabel"
                              inputRef={register}
                              name={`station_payments[${idx}].end_date`}
                              defaultValue={moment(p?.rent?.end_date ?? moment()).format('YYYY-MM-DD')}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                          >
                            <SpTextInput
                              label="Tariffa rispettiva (€)"
                              labelColor={'black'}
                              type="number"
                              step="0.01"
                              min="1"
                              formControlStyle={formControlStyleInput}
                              variant="inputLabel"
                              inputRef={register}
                              name={`station_payments[${idx}].amount_to_pay`}
                              defaultValue={p.amount_to_pay}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                          >
                            <SpIconButton
                              small
                              buttonType={'accept'}
                              style={{ marginTop: 25 }}
                              onClick={() => remove(fields.findIndex((e) => e.id == p.id)) + 1}
                            >
                              <Close />
                            </SpIconButton>
                          </Grid>
                        </Grid>
                      );
                    case 3:
                      return (
                        <Grid
                          key={p.id}
                          item
                          xs={12}
                          container
                          alignItems="center"
                          justifyContent="flex-start"
                        >
                          <Grid
                            item
                            xs={3}
                          >
                            <SpTextInput
                              label="Tariffa per la cauzione (€)"
                              labelColor={'black'}
                              type="number"
                              step="0.01"
                              min="1"
                              formControlStyle={formControlStyleInput}
                              variant="inputLabel"
                              inputRef={register}
                              name={`station_payments[${idx}].amount_to_pay`}
                              defaultValue={p.amount_to_pay}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                          >
                            <SpIconButton
                              small
                              buttonType={'accept'}
                              style={{ marginTop: 25 }}
                              onClick={() => remove(fields.findIndex((e) => e.id == p.id)) + 1}
                            >
                              <Close />
                            </SpIconButton>
                          </Grid>
                        </Grid>
                      );
                  }
                })}
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default withSnackbar(StationDetail);
